import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#004081",
    },
    secondary: {
      main: "#A54201",
    },
    tertiary: {
      main: "#757575",
    },
    white: "#FFFFFF",
    appButton: "#040202",
    text: {
      primary: "#040202",
      secondary: "#FFFFFF",
    },
    colors: {
      neutral: "#757575",
      neutralLight: "#363636",
      light: "#C7C7C7",
      brandColorPrimary: "#040202",
      background: "#FFFCF9",
    },
  },
  font: {
    aBeeZee: "'ABeeZee', sans-serif",
    outFit: "'Outfit', sans-serif",
    aBhayaLibra: "Abhaya Libre",
    jacques: '"Jacques Francois Shadow", cursive',
  },
  typography: {
    fontFamily: "'Outfit', sans-serif",
    variants: {
      customText: {
        fontFamily: "Roboto",
      },
      aBeeZee: {
        fontFamily: "'ABeeZee', sans-serif",
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#040202",
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        // Name of the slot
        noOptions: {
          // Some CSS
          color: "#A54201",
        },
      },
    },
  },
});
